import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { getCommunityCases} from '../repository/api'
import BelizeMap from './Map'
import virusIcon from '../icons/virus.png';
import { sortData } from '../utils/utils';

export default function MapSection() {
  const getVillages = (e: any) => {
    console.log(e.target.getAttribute('data-value'));
    refetch()
  }; 

  const { data, isLoading, error, refetch } = useQuery('communitycases', getCommunityCases,{refetchOnWindowFocus: false});
  const [ mapData, setMapData ] = useState([]);
  const [ mapAreas, setMapAreas ] = useState([]);

    useEffect(() => { 
      if(data) { 
        const formattedCommunityData = data?.data.features.map((attributes: any) => {
          const data = {
           'name':  attributes?.attributes.DISTRICT,
           'x': attributes?.attributes.x,
           'y': attributes?.attributes.y,
           'village': attributes?.attributes.SETTNAME,
          }
          return data;
       }); 
        setMapData(formattedCommunityData);
        const formattedApiData: any = sortData(formattedCommunityData, 'name');   
        setMapAreas(formattedApiData);
        formattedApiData.Belize.forEach((village: any)=> {
          // console.log("village", village);
          // L.marker([village.x, village.y], { icon: virusIcon })
          // .addTo(mymap)
          // .bindPopup(`<b>${village.village}: cases 🦠</b>`)
          // .openPopup(); 
        });
      }
 
    }, [data, isLoading])

    // console.log("Map areas", Object.values(mapAreas).forEach(name => console.log(name)))
    const allData = Object.keys(mapAreas).map((area, index) => {  
      return (
          <div key={index} className="district-area">
                 {area}{' '}
                <span className="virus" role="img" aria-label="virus">
                  🦠
                </span>
          </div>
        );
      });
  
  return (
    <div className="map-container">
    <div className="map-container-inner">
      <div className="map-data-col">
        <h1 className="paper-title">View Cases on Map</h1>
        <div className="districts-row">
          <div className="district" onClick={(e) => getVillages(e)} data-value="corozal">
            Corozal
          </div>
          <div className="district" onClick={(e) => getVillages(e)} data-value="belize">
            Belize
          </div>
          <div className="district" onClick={(e) => getVillages(e)} data-value="orangewalk">
            Orange Walk
          </div>
          <div className="district" onClick={(e) => getVillages(e)} data-value="cayo">
            Cayo
          </div>
          <div className="district" onClick={(e) => getVillages(e)} data-value="stanncreek">
            Stann Creek
          </div>
          <div className="district" onClick={(e) => getVillages(e)} data-value="toledo">
            Toledo
          </div>
        </div>
        <div className="affected-areas">
          { 
            allData
          }
        </div>
      </div>
      {/* <BelizeMap data={mapData} isLoading={isLoading} /> */}
    </div>
  </div>
  )
}
